import { render } from "./BlogCard.vue?vue&type=template&id=62443df1&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"

import "./BlogCard.vue?vue&type=style&index=0&id=62443df1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62443df1"]])

export default __exports__